import { Box, Button, Card, CardActions, CardContent, CardHeader, LinearProgress, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

function InterviewCard({ campaign }: { campaign: Campaign }) {
  return (
    <Card
      style={{
        width: "100%",
        height: "100%",
      }}>
      <CardHeader
        title={campaign.name}
        titleTypographyProps={{
          fontSize: "16px",
          fontWeight: "bold",
        }}
      />
      <CardContent>
        <Typography variant="body2" my="16px" color="text.secondary">
          {campaign.description}
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2, justifyContent: "space-between", my: 2 }}>
          <Typography variant="body2" color="text.secondary">
            {campaign.answers?.length || 0}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {campaign.maxAnswers}
          </Typography>
        </Box>
        <LinearProgress
          variant="determinate"
          value={((campaign.answers?.length || 0) / (campaign.maxAnswers || 1)) * 100}
          sx={{
            height: "10px",
            borderRadius: "10px",
            my: "16px",
          }}
        />
      </CardContent>
      <CardActions>
        <Button
          component={Link}
          to={`/answer/${campaign.id}`}
          variant="outlined"
          fullWidth
          size="large"
          sx={{
            textTransform: "none",
            // fontWeight: "bold",
          }}>
          Take interview
        </Button>
      </CardActions>
    </Card>
  );
}

export default InterviewCard;
